import { render, staticRenderFns } from "./PageElementsForm.vue?vue&type=template&id=af83d9b6&"
import script from "./PageElementsForm.vue?vue&type=script&lang=js&"
export * from "./PageElementsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports